import {ANSWER_START, ANSWER_SUCCESS, ANSWER_FAIL, ANSWER_RESET} from './constants';
import {AnswerActions, AnswerState} from './types';

const initialState: AnswerState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: AnswerActions,
): AnswerState => {
  switch (action.type) {
    case ANSWER_START:
      return {
        ...initialState,
        loading: true,
      };
    case ANSWER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ANSWER_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case ANSWER_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
